import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CollectionType, IFavoriteCollectionViewModel } from "Services/API/API";
import { CollectionMenu } from "./CollectionMenu";

export interface CollectionProps {
   collection: IFavoriteCollectionViewModel,
   renameCallback: () => Promise<void>,
   deleteCallback: (collectionType: CollectionType | undefined) => Promise<void>,
   copyCallback: () => Promise<void>,
   count?: number | undefined
}

export const Collection: React.FC<CollectionProps> = ({ collection, renameCallback, deleteCallback, copyCallback, count }) => {

   useEffect(() => {
      const abortController = new AbortController();

      return function cleanup() {
         abortController.abort();
      }
   }, []);

   return (
      <div key={collection.id} className="regular-collection-wrapper">
         <div className="inner container">
            <Link to={`/workspaces/${collection.id}`} style={{ pointerEvents: collection.images?.length === 0 ? "none" : "auto" }}>
               <div className="row images">
                  {(collection.images?.length == 3 || collection.images?.length == 4) && collection.images?.map((img, i) =>
                     <div key={i} className={(collection.images?.length === 3 && i === 2 ? "col-12" : "col-6")} style={{ backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "center", height: "124px" }}></div>)}
                  {collection.images?.length == 2 && collection.images?.map((img, i) =>
                     <div key={i} className="col-12" style={{ backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "center", height: "124px" }}></div>)
                  }
                  {collection.images?.length == 1 && collection.images?.map((img, i) =>
                     <div key={i} className="col-12" style={{ backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "center", height: "248px" }}></div>)
                  }
                  {collection.images?.length == 0 && <>
                     <div key={0} className="col-6" style={{ backgroundColor: "#CFD4D4", backgroundSize: "cover", backgroundPosition: "center", height: "124px" }}></div>
                     <div key={1} className="col-6" style={{ backgroundColor: "#DADFDF", backgroundSize: "cover", backgroundPosition: "center", height: "124px" }}></div>
                     <div key={2} className="col-6" style={{ backgroundColor: "#DADFDF", backgroundSize: "cover", backgroundPosition: "center", height: "124px" }}></div>
                     <div key={3} className="col-6" style={{ backgroundColor: "#CFD4D4", backgroundSize: "cover", backgroundPosition: "center", height: "124px" }}></div></>
                  }
               </div>
            </Link>
            <div className="row description">
               <div className="col-8 col-md-6 left">
                  <Link to={`/workspaces/${collection.id}`} className="h7 collection-name">{collection.name}</Link>
                  <div className="p2">{collection.numberOfSpaces} spaces</div>
               </div>
               <div className="col-4 col-md-6 right">
                  <CollectionMenu collection={collection} count={count} collectionUrl={collection.url} renameCallback={renameCallback} deleteCallback={deleteCallback} copyCallback={copyCallback} />
               </div>
            </div>
         </div>
      </div>
   );
}